import { Box, Spacing, Stack, styled } from 'ui';

export const StyledButtonContent = styled('div')`
  display: flex;
  padding: ${({ theme }) => theme.spacing(Spacing.Small)};
  gap: ${({ theme }) => theme.spacing(Spacing.Small)};
  justify-content: flex-end;
  width: 100%;
`;

export const StyledTitleStack = styled(Stack)`
  gap: ${({ theme }) => theme.spacing(Spacing.Tiny)};
`;

export const StyledStack = styled(Stack)`
  display: flex;
  width: 600px;
  min-height: 250px;
  gap: ${({ theme }) => theme.spacing(Spacing.Medium)};
  @media (max-width: 768px) {
    width: 380px;
  }
  padding: ${({ theme }) => theme.spacing(Spacing.Large, Spacing.Medium)};
`;

export const StyledBox = styled(Box)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(Spacing.Medium)};
`;

export const FieldStackContainer = styled(Stack)`
  width: 100%;
  gap: ${({ theme }) => theme.spacing(Spacing.Medium)};
`;

export const StyledBoxContainer = styled(Box)`
  height: 450px;
`;
